import { render } from "./DeleteButton.vue?vue&type=template&id=01ec7e58&scoped=true&ts=true"
import script from "./DeleteButton.vue?vue&type=script&lang=ts"
export * from "./DeleteButton.vue?vue&type=script&lang=ts"

import "./DeleteButton.vue?vue&type=style&index=0&id=01ec7e58&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01ec7e58"]])

export default __exports__